import {
  GenerateRequest,
  GenerateResponse,
  HasherQuote,
  HasherQuoteStop,
  ValidateRequest,
  ValidateResponse,
} from './types';
import { JobQuote, JobQuoteStop } from '../freedomQl/__generated__/graphql';

import { post as basePost } from '../lowLevel';
import config from '@/config';
import { getIsoOffsetfromCoordinates } from '@/utils/dateManipulation';
import { getValidToken } from '@/services/auth/authProxy';
import { round } from '@/utils/helpers';

const post = async (path: string, body: any): Promise<any> => {
  return (
    await basePost(
      [config.services.functionsUrl],
      path,
      body,
      await getHeaders(),
    )
  )?.data;
};

const getHeaders = async () => {
  return {
    Authorization: `Bearer ${(await getValidToken()).access_token}`,
  };
};

export const postGenerateQuoteId = (
  body: GenerateRequest,
): Promise<GenerateResponse> => post('hasher/generate', body);

export const postValidateQuoteId = (
  body: ValidateRequest,
): Promise<ValidateResponse> => post('hasher/validate', body);

export const mapJobQuoteToQuotePayload = (jobQuote: JobQuote): HasherQuote => {
  const { lat, long } = jobQuote.jobQuoteStops[0];
  return {
    tariffRef: jobQuote.tariffRef ?? 0,
    pickupDt: getIsoOffsetfromCoordinates(jobQuote.pickupDt, lat, long),
    waitReturn: jobQuote.waitReturn ?? 'NO',
    stops: jobQuote.jobQuoteStops.map(mapJobQuoteStopToQuoteStop),
  };
};

const mapJobQuoteStopToQuoteStop = (stop: JobQuoteStop): HasherQuoteStop => ({
  dropOrder: stop.dropOrder ?? 0,
  postcode: stop.postcode ?? '',
  countryCode: stop.countryCode ?? '',
  gridX: stop.gridX !== null ? round(stop.gridX, 6) : null,
  gridY: stop.gridY !== null ? round(stop.gridY, 6) : null,
  stopTime: stop.stopTime !== null ? round(stop.stopTime, 2) : null,
});
